var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FigureSlider',{attrs:{"images":_vm.isEmpty(_vm.mappedImages) ? _vm.noImgPlaceholder : _vm.mappedImages,"use-related-and-conjugates-u-i":_vm.useRelatedAndConjugatesUI}})}
var staticRenderFns = []

export { render, staticRenderFns }